import { render, staticRenderFns } from "./ContactNumberCapture.vue?vue&type=template&id=25a05846&scoped=true"
import script from "./ContactNumberCapture.vue?vue&type=script&lang=js"
export * from "./ContactNumberCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a05846",
  null
  
)

export default component.exports